// extracted by mini-css-extract-plugin
export var grid = "_2z-0";
export var span1 = "_2z-2";
export var span10 = "_2z-b";
export var span10L = "_2z-z";
export var span10M = "_2z-n";
export var span10Xl = "_2z-1b";
export var span11 = "_2z-c";
export var span11L = "_2z-10";
export var span11M = "_2z-o";
export var span11Xl = "_2z-1c";
export var span12 = "_2z-d";
export var span12L = "_2z-11";
export var span12M = "_2z-p";
export var span12Xl = "_2z-1d";
export var span1L = "_2z-q";
export var span1M = "_2z-e";
export var span1Xl = "_2z-12";
export var span2 = "_2z-3";
export var span2L = "_2z-r";
export var span2M = "_2z-f";
export var span2Xl = "_2z-13";
export var span3 = "_2z-4";
export var span3L = "_2z-s";
export var span3M = "_2z-g";
export var span3Xl = "_2z-14";
export var span4 = "_2z-5";
export var span4L = "_2z-t";
export var span4M = "_2z-h";
export var span4Xl = "_2z-15";
export var span5 = "_2z-6";
export var span5L = "_2z-u";
export var span5M = "_2z-i";
export var span5Xl = "_2z-16";
export var span6 = "_2z-7";
export var span6L = "_2z-v";
export var span6M = "_2z-j";
export var span6Xl = "_2z-17";
export var span7 = "_2z-8";
export var span7L = "_2z-w";
export var span7M = "_2z-k";
export var span7Xl = "_2z-18";
export var span8 = "_2z-9";
export var span8L = "_2z-x";
export var span8M = "_2z-l";
export var span8Xl = "_2z-19";
export var span9 = "_2z-a";
export var span9L = "_2z-y";
export var span9M = "_2z-m";
export var span9Xl = "_2z-1a";
export var stretch = "_2z-1";